import React from 'react';
import {CloseStrokeIcon,} from "../../../image";
import './ConfirmationModal.scss';
import {Modal} from "antd";

const  ConfirmationModal = (props) => {
    const {show, onClose, title, description, cancelButton,confirmButton} = props;

    return (
        <Modal
            open={show}
            onCancel={onClose}
            centered
            classNames={{
                mask: 'confirmation-modal__mask',
                content: 'confirmation-modal__content',
                wrapper: 'confirmation-modal__wrapper',
            }}
            className={'delete-user-modal'}
            onWheel={(e) => e.stopPropagation()}
        >
            <div>
                <div className="confirmation-modal__header">
					<span className="confirmation-modal__header--title">
						{title}
					</span>
                    <CloseStrokeIcon onClick={onClose}/>
                </div>
                <div className="confirmation-modal__body">
					<span className="confirmation-modal__body--text">
						{description}
					</span>
                </div>
                <div className="confirmation-modal__footer">
                    {cancelButton}
                    {confirmButton}
                </div>
            </div>

        </Modal>
    );
};

export default ConfirmationModal;